import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("analytics", "true", { expires: 365 }); // Set analytics cookie
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const handleDeny = () => {
    Cookies.set("analytics", "false", { expires: 365 }); // Block analytics
    localStorage.setItem("cookieConsent", "denied");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="tc-box">
      <p className="text-sm">We use cookies to enhance your experience. By continuing, you accept our cookie policy.</p>
      <div className="tc-box-btn-box">
        <button onClick={handleAccept} className="accept-all">Accept All</button>
        <button onClick={handleDeny} className="deny-all">Deny All</button>
      </div>
    </div>
  );
};

export default CookieConsent;
